import { clsx } from 'clsx';
import { ReactNode } from 'react';

const FEATURE_FLAGS_GRID_COLUMNS =
  'grid-cols-[200px_minmax(250px,1fr)_100px_100px_100px_minmax(220px,2fr)_60px]';

export const FeatureFlagsGrid = ({
  actions,
  customProperties,
  description,
  isEnabled,
  isEnabledAdmin,
  isEnabledDev,
  name,
}: {
  actions?: ReactNode;
  customProperties: ReactNode;
  description: ReactNode;
  isEnabled: ReactNode;
  isEnabledAdmin: ReactNode;
  isEnabledDev: ReactNode;
  name: ReactNode;
}) => {
  return (
    <div className={clsx('grid gap-4 px-4', FEATURE_FLAGS_GRID_COLUMNS)}>
      <div className="truncate">{name}</div>
      <div className="truncate">{description}</div>
      <div className="justify-self-center">{isEnabled}</div>
      <div className="justify-self-center">{isEnabledAdmin}</div>
      <div className="justify-self-center">{isEnabledDev}</div>
      <div>{customProperties}</div>
      <div className="justify-self-center">{actions}</div>
    </div>
  );
};
